export default __webpack_public_path__ + "assets/8dd3fbafe066de4d0a0c96eea072f020.png";